const zhTW = {
  // Navigation
  nav: {
    about: '關於我們',
    business: '業務介紹',
    stats: '案例研究',
    news: '最新消息',
    contact: '聯絡我們',
    values: '企業理念',
    recruitment: '徵才資訊',
    security: '資訊安全',
    topPage: '首頁',
  },
  
  // Services
  services: {
    title: '服務項目',
  },
  
  // Footer
  footer: {
    copyright: '© 2026 TradFit Co., Ltd.',
    privacy: '隱私權政策',
  },
  
  // Carousel
  carousel: {
    slide1: {
      title: '用生成式 AI 開創未來',
      description: '利用尖端 AI 技術無限擴展商業可能性。從數據中創造價值，提供創新解決方案。'
    },
    slide2: {
      title: '由生成式 AI 引領的下一代商業',
      description: '利用機器學習和深度學習加速企業成長。支援智慧決策。'
    },
    slide3: {
      title: '實現生成式 AI 的創新',
      description: '利用生成式 AI 技術平衡創造力與效率。為您的業務量身打造最佳 AI 解決方案。'
    },
    learnMore: '了解更多'
  },
  // Hero
  hero: {
    title: 'TradFit 的使命是利用生成式 AI 的力量重新定義客戶的業務流程，',
    subtitle: '並透過為客戶創造新價值來實現「三方受益（三方よし）」。',
    whoAreWe: '[關於我們]',
    tagline: '不分行業、業態或公司規模，利用生成式 AI 的力量支持客戶成長。',
  },
  
  // Footer tagline
  footerTagline: '生成式 AI 及語音 AI 領域的領先企業。\n以東京丸之內為據點，致力於解決日本的各項課題。',

  // Home page
  home: {
    heroTitle: '用生成式 AI',
    heroTitleHighlight: '開創未來',
    heroSubtitle: '利用尖端 AI 技術無限擴展商業可能性。從數據中創造價值，提供創新解決方案。',
    heroCta1: '查看業務內容',
    heroCta2: '聯絡我們',
    missionText: 'TradFit 的使命是利用生成式 AI 的力量重新定義客戶的業務流程，並透過為客戶創造新價値來實現「三方受益（三方よし）」。',
    servicesTag: '我們的服務',
    servicesTitle: '實現創新',
    servicesSubtitle: '結合尖端 AI 技術與深厚的行業知識，為您的業務挑戰提供最佳解決方案。',
    techTag: '技術',
    techTitle: '我們的技術領域',
    techSubtitle: '利用尖端技術，從多個角度解決您的業務挑戰。',
    aboutTag: '關於我們',
    aboutTitle: '為日本商業帶來創新',
    aboutSubtitle: 'TradFit 株式會社總部位於東京千代田區丸之內，自 2017 年成立以來，作為生成式 AI 和語音 AI 的領先企業，支援 DX 推進',
    aboutText1: '以生成 AI、語音 AI 技術及精密的知財產權戰略為核心，全面支援企業數位轉型。',
    aboutText2: '從行銷諮詢到系統開發，我們提供廣泛的服務，不分行業、業態或規模，致力於解決客戶的課題。',
    aboutBtn: '查看公司概況',
    newsTag: '最新消息',
    newsTitle: '最新資訊',
    newsViewAll: '查看全部',
    servicesViewAll: '查看業務內容',
    ctaTitle: '利用生成式 AI 將您的業務提升到下一個階段',
    ctaSubtitle: '歡迎隨時諮詢。',
    ctaBtn: '聯絡我們',
    service1Title: '生成式 AI 諮詢・開發支援',
    service1Desc: '利用尖端生成式 AI 技術，支援業務效率化和創新創造。從策略規劃到實施提供全面支援。',
    service2Title: 'Hospitalia 語音 AI 解決方案',
    service2Desc: '日本首家獲得 Alexa SP 認證的語音 AI 平台。為觀光、醫療和地方政府提供行業專屬解決方案。',
    service3Title: '網路安全服務',
    service3Desc: '超過 20 年零事故的壓倒性實績。根據客戶需求，從 AD 伺服器到所有終端靈活導入。',
    service4Title: '生成式 AI 行銷支援',
    service4Desc: '利用生成式 AI 革新內容製作。透過數據驅動的目標定位和最佳化，最大化行銷 ROI 並提升品牌價值。',
    tech1Title: '生成式 AI',
    tech1Desc: '利用 LLM、圖像和語音生成的內容及業務自動化解決方案',
    tech2Title: '人工智慧',
    tech2Desc: '機器學習、深度學習、自然語言處理（NLP）及其他 AI 技術',
    tech3Title: '機器人技術',
    tech3Desc: '與自律移動機器人和服務機器人的 AI 系統整合及導入支援',
    tech4Title: '實體 AI',
    tech4Desc: '在現實空間中自律判斷和行動的 AI 系統設計與構建',
    tech5Title: 'IoT',
    tech5Desc: '透過智慧設備、感測器和雲端整合的即時數據利用基礎設施',
    tech6Title: '生物識別',
    tech6Desc: '透過聲紋、臉部識別、虹膜、指紋和靜脈認證進行安全身份驗證',
    tech7Title: '大數據',
    tech7Desc: '透過大規模數據收集、分析和視覺化支援數據驅動管理',
    tech8Title: '知財·專利',
    tech8Desc: '擁有大量與AI、軟體及商業模式相關的知財產權',
    learnMore: '了解更多',
    newsItem1: '進行以減輕醫療從業人員負擔和提高住院患者滿意度為目標的語音輔助病房概念驗證',
    newsItem2: '前野村證券專務、前野村総合研究所副會長百瀬裕規氏就任 TradFit 公司執行顧問',
    newsItem3: '獲 Travel Voice 報導。TradFit 與 NEC Networks & System Integration 簽署經銷協議，強化 AI 語音服務「Hospitalia」支援體制',
    newsItem4: '透過 Alexa Smart Properties 支援觀光、住宿、醫療產業及地方政府的業務效率化與生產力提升',
  },

  // News hero subtitle
  newsHeroSubtitle: '新聞・新聞稿・活動資訊',

  // Language
  language: {
    english: 'English',
    japanese: '日本語',
    korean: '한국어',
    chinese: '繁體中文',
  },

  // About Page
  about: {
    title: '公司概況',
    subtitle: '關於我們',
    missionTitle: 'TradFit 的使命',
    missionText1: 'TradFit 的使命是利用生成式 AI 的力量重新定義客戶的業務流程，並透過為客戶創造新價値來實現「三方受益（三方よし）」。',
    missionText2: '我們的優勢在於擁有國內外強大的專利組合，由精通生成式 AI 和商業的菁英團隊驅動，具備壓倒性的交付速度，以及加速業務攻守兼備的智慧財產權戰略。',
    valuesTitle: 'TradFit 的價值觀',
    businessContent: '業務內容（國內外專利已取得及申請中）',
    businessItems: [
      '生成式 AI 諮詢事業',
      '生成式 AI 開發事業',
      '生成式 AI 行銷事業',
      '網路安全事業',
      '觀光・醫療・地方政府語音 AI 解決方案（Hospitalia）',
    ],
    businessNote: '國內外專利已取得・申請中',
    businessContentText: '① 觀光、醫療、地方政府語音 AI 解決方案 (Hospitalia) ② 生成式 AI 諮詢・開發支援服務 ③ 網路安全防護服務 ④ 生成式 AI 行銷支援服務（包含語音 AI 數據平台建構與運營。已取得國內外專利）',
    companyInfo: '公司資訊',
    companyName: '公司名稱',
    companyNameValue: 'TradFit 株式會社',
    companyNameEn: 'TradFit Co., Ltd.',
    established: '成立時間',
    establishedValue: '2017年8月',
    capital: '資本金',
    capitalValue: '1億日圓',
    ceo: '代表取締役',
    ceoValue: '戸田 良樹',
    headquarters: '總部所在地',
    headquartersPostal: '100-0005',
    headquartersAddress1: '東京都千代田區丸之內 1-6-5',
    headquartersAddress2: '丸之內北口大樓 9F',
    contact: '聯絡方式',
    shareholders: '股東',
    shareholdersText: '日生資本株式會社（日本生命集團）、GMO VenturePartners 株式會社、Pasona Group Inc.、事業創造資本株式會社（NSG 集團）、經營團隊等',
    affiliations: '所屬團體',
    affiliation1: 'AWS 合作夥伴軟體路徑 國際認證',
    affiliation2: 'Google Cloud™ Build Partner 國際認證',
    affiliation3: '日本住宿業相關協會 (JARC)',
    affiliation4: '日本觀光振興協會',
    affiliation5: '東京觀光財團',
    majorClients: '客戶（部分列舉）',
    majorClientsText: 'IT 業界、專業服務業界、個人事業主、美容業界、婚潮業界、學校法人業界、房地產業界、鐵路業界、住宿業界・醫療業界等',
    partners: '合作廠商（部分列舉）',
    partnersText: '國內外中小企業、中堅企業、大型企業等',
    awards: '獲獎經歷（部分摘錄）',
    award1: '被認證為新潟縣創新新創企業「J-Startup NIIGATA」',
    award2: '被 Travel Voice 株式會社選為國內外值得關注的 10 家企業之一',
    award3: '榮獲經濟產業省/特許廳第 3 屆「IP BASE AWARD」獎勵賞（新創部門）',
    award4: '榮獲 NIIGATA VENTURE AWARD 2022 最優秀賞',
    award5: '榮獲一般社團法人日本新創支援協會主辦的「The JSSA MeetUp & Award Vol.39」最優秀賞',
    award6: '被 APAC CIOoutlook 選為「2022 年十大認知解決方案供應商」',
    award7: '被 The Silicon Review 選為「2022 年十大道德企業」',
    award8: '被 The Enterprise World 選為「年度進取企業」',
    award9: '連續 3 年入選亞洲百大企業',
    award10: '連續 3 年入選最佳創投 100 強',
  },

  values: {
    title: '企業理念',
    subtitle: 'Values',
    sixValues: '6 大核心價值觀',
    clientFirst: '客戶至上',
    clientFirstDesc: '我們將客戶的成功置於首位。每一項策略、每一個決策、每一個行動，都旨在為我們服務的對象提供最大的價值。',
    dataDriven: '數據驅動卓越',
    dataDrivenDesc: '我們相信數據的力量能夠指引前進的方向。我們的決策基於嚴謹的分析和可衡量的結果。',
    innovation: '創新與敏捷',
    innovationDesc: '在快速變化的數位環境中，我們透過擁抱變革、嘗試新方法並迅速適應市場趨勢來保持領先。',
    integrity: '誠信與透明',
    integrityDesc: '我們透過誠實的溝通、道德的實踐和透明的報告來建立信任。客戶始終清楚自己的處境。',
    collaboration: '合作夥伴關係',
    collaborationDesc: '我們與客戶一起工作。客戶的成功是透過真正的合作和共同的承諾實現的。',
    improvement: '持續改進',
    improvementDesc: '我們從不滿足於現狀。我們不斷改進方法、擴展知識，並持續改善我們的服務。',
    living: '實踐我們的價值觀',
    livingText: '這些價值觀不僅僅是口號。它們是我們文化的基石，也是指導我們日常工作的指南針。每一位 TradFit 團隊成員都體現了這些原則，確保客戶不僅獲得卓越的服務，還能建立基於信任、卓越和共同成功的合作夥伴關係。',
    workWithUs: '與我們合作',
  },

  // Business Page
  business: {
    title: '我們的業務',
    subtitle: '業務介紹',
    marketingConsultingTitle: '行銷諮詢',
    marketingConsultingDesc: '加速業務成長的策略行銷規劃與執行支援',
    newBusinessTitle: '新業務開發',
    newBusinessDesc: '為啟動和擴展新業務提供全面支援',
    crmConsultingTitle: 'CRM 諮詢',
    crmConsultingDesc: '客戶關係管理 (CRM) 的優化與導入',

    hrConsultingDesc: '人力資源策略與人才發展解決方案',
    dataMarketingTitle: '數據行銷',
    dataMarketingDesc: '用於行銷優化的進階數據分析與洞察',
    adMarketingTitle: '廣告行銷',
    adMarketingDesc: '全面的廣告活動管理與優化',
    snsMediaMarketingTitle: '社群媒體與媒體行銷',
    snsMediaMarketingDesc: '社群媒體策略與內容行銷解決方案',
    webCreationTitle: '網站製作',
    webCreationDesc: '專業的網站設計與開發服務',
    videoBrandingTitle: '影片品牌推廣',
    videoBrandingDesc: '影片製作與品牌敘事服務',
    systemDevelopmentTitle: '系統開發',
    systemDevelopmentDesc: '客製化軟體與系統開發解決方案',
    learnMore: '了解更多',
    integratedApproach: '整合式方法',
    integratedText: '我們整合行銷、技術和創意領域的專業知識，支援您實現業務目標。',
    discussProject: '討論專案',
    
    // Service 1: Hospitalia
    hospitaliaTitle: 'Hospitalia 語音 AI 解決方案',
    hospitaliaDesc: '日本首家獲得 Alexa SP 認證的語音 AI 平台。為觀光、醫療和地方政府提供行業專屬解決方案。',
    hospitaliaDetail1Title: '大幅降低營運負擔',
    hospitaliaDetail1: 'Hospitalia 透過自動化詢問、支援多種語言及簡化任務管理，大幅改善現場營運負擔。員工可以回應客戶需求，而不會被客房來電或櫃台詢問淹沒。',
    hospitaliaDetail2Title: '回應多樣化需求',
    hospitaliaDetail2: '我們針對各行業的具體需求提供靈活且有效的解決方案，例如提升住宿設施的賓客體驗價值，以及支援醫療和護理現場的高效運營。透過貼近客戶問題並提出最佳解決方案，我們支援營運效率和服務品質的提升。',
    hospitaliaDetail3Title: '以智慧音箱為樞紐提出新體驗',
    hospitaliaDetail3: '透過以智慧音箱為樞紐連結各種設備和服務，我們提供更便利、舒適的環境。例如，在住宿設施中，客人可以透過智慧音箱輕鬆語音控制房內燈光和空調、向櫃台詢問以及預訂客房服務。在醫療和護理現場，語音助理可用於減少護士呼叫的回應。這在提高現場營運效率的同時，也為使用者提供了直觀且易於使用的體驗。',
    
    // Service 2: AI Consulting
    aiConsultingTitle: '生成式 AI 諮詢・開發支援',
    aiConsultingDesc: '利用尖端生成式 AI 技術，支援業務效率化和創新創造。從策略規劃到實施提供全面支援。',
    aiConsultingDetail1Title: '背景與必然性',
    aiConsultingDetail1: '善用生成式 AI，是未來企業營運中堪稱命脈的關鍵課題。本公司認為，能夠活用生成式 AI 的企業與無法活用的企業，其生產力差距將以加速度持續擴大。生成式 AI 的應用領域不僅限於系統效率化，更有可能大幅提升一般業務、後台業務、管理業務等所有業務的生產力。透過將本公司在生成式 AI 開發與應用方面的專業知識提供給客戶，我們相信能夠貢獻於提升工作者的工作與生活平衡，以及實現更穩定的收益性改善。',
    aiConsultingPoint1: 'DX 推進',
    aiConsultingPoint1Desc: '企業等各種業務均可透過生成式 AI 實現效率化。可從各個層面推進 DX。例如，可進行 DX 化的業務範圍廣泛，包括業務輔助、各種詢問、廣告行銷等。',
    aiConsultingPoint2: '透過再培訓支援內製化',
    aiConsultingPoint2Desc: '隨著個人層面的生成式 AI 應用範圍擴大，整個組織的生產力將得到飛躍性的提升。本公司提供陪跑支援，協助企業將生成式 AI 應用內製化，進一步實現業務效率化。',
    aiConsultingPoint3: '高速新事業開發',
    aiConsultingPoint3Desc: '透過正確活用生成式 AI，可以飛躍性地加快新事業開發的速度。',
    aiConsultingDetail2: '',
    aiConsultingDetail3: '',
    
    // Service 3: Website Creation
    websiteCreationTitle: '生成式 AI 網站製作服務',
    websiteCreationDesc: '利用生成式 AI 的力量，建立更簡單、更具溝通性的網站',
    websiteCreationDetail1: '我們利用生成式 AI 的力量改造您的網站。',
    websiteCreationDetail2: '我們傾聽您的需求，最快在 2-3 週內建立您的首頁。我們建立訪客易於使用的首頁，並確保現代首頁所需的安全性與顯示速度。',
    websiteCreationDetail3: '傳統的網頁製作服務主要提供公司資訊和諮詢表單等基本元素。',
    websiteCreationDetail4: '在本服務中，我們可以回應廣泛的需求，如電商網站建置、CMS（內容管理系統）和部落格安裝。',
    websiteCreationDetail5: '此外，網站發布後，請將網站維護交給我們。客戶無需進行任何維護。',
    closeModal: '關閉',
    contactUs: '聯絡我們',
    mainServicesTitle: '核心服務',
    mainServicesSubtitle: '結合尖端 AI 技術與深厚的行業知識，為您的業務挑戰提供最佳解決方案。',

    // Service 4: Cyber Security
    cyberSecurityTitle: '網路安全服務',
    cyberSecurityDesc: '超過 20 年零事故的壓倒性實績。根據客戶需求，從 AD 伺服器到所有端點靈活導入。',
    cyberSecurityDetail1Title: '壓倒性的實績',
    cyberSecurityDetail1: '本公司提案的網路安全產品，擁有超過 20 年零事故的壓倒性實績。',
    cyberSecurityDetail2Title: '可從部分伺服器及終端開始導入',
    cyberSecurityDetail2: '從僅導入身份驗證基礎設施 AD（Active Directory）伺服器，到導入至所有終端，可根據客戶意願進行導入。',
    cyberSecurityDetail3Title: '大型企業及醫院等眾多客戶已導入',
    cyberSecurityDetail3: '對安全要求嚴格的大型企業及醫院的導入正在增加。',

    // Service 5: AI Marketing
    aiMarketingTitle: '生成式 AI 行銷支援',
    aiMarketingDesc: '利用生成式 AI 革新內容製作。透過數據驅動的目標定位和最佳化，最大化行銷 ROI 並提升品牌價值。',
    aiMarketingDetail1Title: '利用生成式 AI 革新內容制作',
    aiMarketingDetail1: '透過利用生成式 AI，可以以傳統方法數倍的速度制作高品質的行銷內容。自動生成和最佳化包括部落格文章、SNS 貼文、廣告文案、電子報組在內的所有內容，大幅提升行銷活動的生產力。',
    aiMarketingDetail2Title: '數據驅動的目標定位與最佳化',
    aiMarketingDetail2: '透過結合生成式 AI 和機器學習，深入分析客戶數據并制定最佳目標定位策略。透過廣告投放自動最佳化、個人化訊息傳遞和即時 A/B 測試，最大化行銷 ROI。',
    aiMarketingDetail3Title: '品牌強化與提升客戶參與度',
    aiMarketingDetail3: '透過利用生成式 AI 的品牌故事述說，與客戶建立深層關係。透過包括 SNS 行銷、網紅合作、社群建立在內的多角度方法，提升客戶參與度带提升長期品牌價値。',
  },

  // Stats Page
  stats: {
    title: '實績',
    description: '不分行業、業態或規模，利用生成式 AI 的力量支持客戶成長。',
    clientCategoriesTitle: '合作客戶（部分摘錄）',
    clientCategories: [
      'IT', '個人事業主', '美容', '診所', '婚紐', '專業職業',
      '學校法人', '房地產', '開發商', '商業設施', '零售', '鐵路',
      '住宅', '飯店', '旅館', '民宿', '餐飲', '長期照護',
      '醫院', '清潔', '製造業', '人才介紹', '配送', '倉儲',
      '金融', '綜合建設', '建設',
    ],
  },

  // News Page
  news: {
    title: '最新消息',
    subtitle: 'NEWS',
    noArticles: '暫無文章',
    backToList: '返回列表',
    articleNotFound: '找不到文章',
    articleNotFoundDesc: '您要查找的文章可能已被刪除，或網址不正確。',
    previousArticle: '上一篇文章',
    nextArticle: '下一篇文章',
    relatedArticles: '相關文章',
    noContent: '沒有內容。',
    share: '分享',
    viewOriginal: '查看原始文章',
    pressRelease: '新聞稿',
    companyNews: '公司新聞',
    event: '活動',
    award: '獲獎',
    item1: 'TradFit 宣布與主要科技公司建立新策略合作夥伴關係',
    item2: '年終業績：行銷諮詢服務創紀錄成長',
    item3: 'TradFit 將主辦 2025 年度行銷高峰會',
    item4: '東京新辦公室啟用',
    item5: 'TradFit 擴大數據分析團隊',
    item6: '獲選為年度最佳行銷諮詢公司',
    item7: '推出全新 CRM 諮詢服務線',
    item8: 'TradFit 慶祝成立 5 週年',
  },

  // SEO
  seo: {
    homeTitle: '東京 生成式 AI 及語音 AI 及網路安全 TradFit 株式會社 | AI 解決方案',
    homeDescription: 'TradFit 株式會社是以東京為據點的生成式 AI 及語音 AI 領先企業。提供 Hospitalia 語音 AI 解決方案、生成式 AI 諮詢與開發支援、網路安全服務、生成式 AI 行銷支援服務。支援企業 DX 推進。',
    homeKeywords: '生成式 AI, 語音 AI, AI 諮詢, 網路安全, 生成式 AI 行銷, DX 推進, 東京',
    aboutTitle: '東京 公司概況 TradFit 株式會社 | 生成式 AI 及語音 AI 企業資訊',
    aboutDescription: 'TradFit 株式會社的公司概況。總部位於東京千代田區的生成式 AI 及語音 AI 領先企業。介紹企業理念、願景及公司資訊。',
    aboutKeywords: '公司概況, TradFit, 生成式 AI 企業, 語音 AI 企業, 東京, 千代田區',
    businessTitle: '東京 業務介紹 TradFit 株式會社 | 語音 AI、生成式 AI、網路安全、行銷',
    businessDescription: 'TradFit 株式會社的業務介紹。提供四大核心服務：Hospitalia 語音 AI 解決方案、生成式 AI 諮詢與開發支援、網路安全服務、生成式 AI 行銷支援服務。',
    businessKeywords: '業務介紹, 生成式 AI 諮詢, 語音 AI, Hospitalia, 網路安全, 生成式 AI 行銷, DX 推進, 東京',
    newsTitle: '東京 最新消息 TradFit 株式會社 | 生成式 AI 及語音 AI 最新資訊',
    newsDescription: 'TradFit 株式會社的最新消息和新聞稿列表。為您送上最新資訊、新聞稿和活動資訊。',
    newsKeywords: '最新消息, 新聞稿, 生成式 AI, 語音 AI, 東京',
    contactTitle: '東京 聯絡我們 TradFit 株式會社 | 生成式 AI 及語音 AI 諮詢',
    contactDescription: 'TradFit 株式會社的聯絡頁面。接受 AI 解決方案導入的諮詢。',
    contactKeywords: '聯絡我們, 諮詢, 生成式 AI 諮詢, 東京',
    statsTitle: '東京 實績與數字 TradFit 株式會社 | 生成式 AI 及語音 AI 企業實績',
    statsDescription: 'TradFit 株式會社的實績與數字。介紹在生成式 AI 及語音 AI 領域的豐富導入實績，以及支援企業 DX 推進的成果。',
    statsKeywords: '實績, 數字, 導入實績, 生成式 AI, 語音 AI, 東京',
    valuesTitle: '企業理念 | TradFit 株式會社',
    valuesDescription: 'TradFit 株式會社的企業理念。介紹客戶至上、數據驅動、創新、誠信、協作、持續改善的 6 大核心價值觀。',
    valuesKeywords: '企業理念, 價值觀, 使命, TradFit',
    recruitmentTitle: '徵才資訊 | TradFit 株式會社',
    recruitmentDescription: 'TradFit 株式會社的徵才資訊。在生成式 AI 及語音 AI 的領先企業，將您的職涯推向下一個階段。',
    recruitmentKeywords: '徵才, 求職, 職涯, AI 企業, 東京',
    privacyTitle: '隱私權政策 | TradFit 株式會社',
    privacyDescription: 'TradFit 株式會社的隱私權政策。已制定個人資料處理方針。',
    privacyKeywords: '隱私權政策, 個人資料保護, TradFit',
    securityTitle: '資訊安全 | TradFit 株式會社',
    securityDescription: 'TradFit 株式會社的資訊安全方針。介紹客戶資料保護與安全對策。',
    securityKeywords: '資訊安全, 資料保護, 安全政策, TradFit',
    servicePageTitle: '提供服務',
    servicePageProcess: '進行方式',
    servicePageBenefits: '導入效益',
    servicePageCtaPrefix: '相關諮詢',
    servicePageCtaHighlight: '先從免費諮詢開始',
    servicePageCtaDesc: '請告訴我們貴公司的課題和需求。TradFit 專家將為您提案最佳解決方案。',
  },

  // Contact Page
  contact: {
    title: '聯絡我們',
    subtitle: '歡迎隨時與我們聯絡',
    sendMessage: '發送訊息',
    name: '姓名',
    email: '電子郵件地址',
    company: '公司名稱',
    phone: '電話號碼',
    subject: '主旨',
    message: '訊息內容',
    send: '發送訊息',
    sending: '發送中...',
    successMessage: '感謝您的訊息。我們會盡快與您聯繫！',
    errorMessage: '發送訊息時發生錯誤。請再試一次。',
    selectSubject: '請選擇主旨',
    generalInquiry: '一般諮詢',
    marketingConsulting: '行銷諮詢',
    dataAnalytics: '數據分析',
    webDevelopment: '網站開發',
    partnership: '合作機會',
    career: '職涯諮詢',
    other: '其他',
    contactInfo: '聯絡資訊',
    address: '地址',
    addressText: 'TradFit 株式會社\n100-0005 東京都千代田區丸之內 1-6-5\n丸之內北口大樓 9F',
    businessHours: '營業時間',
    businessHoursText: '週一至週五：9:00 AM - 6:00 PM (JST)\n週六、週日、國定假日：休息',
    followUs: '追蹤我們',
    characters: '字元',
  },

  articles: [
    {
      date: '2026.01.07',
      category: '案例研究 / 發布',
      title: '前野村證券專務、前野村総合研究所副會長百瀬裕規氏就任 TradFit 公司執行顧問',
      content: `
        <p><strong>TradFit 株式會社（總部：東京都千代田區，代表取締役：戸田 良樹，以下簡稱「TradFit」）利用生成式 AI、語音 AI、IoT、機器人技術、生物識別等技術，以「Hospitalia」為核心開展各種行業的人力短缺解決業務，同時提供生成式 AI 諮詢業務、生成式 AI 開發業務等多項服務。為進一步強化經營體制並推動業務擴展，本公司宣布百瀬裕規氏已就任執行顧問。</strong></p>

        <figure class="wp-block-image">
          <img src="https://prcdn.freetls.fastly.net/release_image/33116/187/33116-187-06be5066e3e4bc5b597aab5ac155500c-3900x2601.jpg?width=1950&height=1350&quality=85%2C65&format=jpeg&auto=webp&fit=bounds&bg-color=fff" alt="" class="w-full h-auto rounded-lg my-6">
        </figure>

        <h3><strong>■ 背景與課題</strong></h3>
        <p>觀光、飯店、日式旅館、醫院、不動產、護理設施、全國各地的地方事業者、行政自治體等，近年來都面臨著人力短缺等重大課題。</p>

        <p>在上述行業及相關行業中，DX（數位轉型）正在加速推進，其中對 AI 領域的期待尤為高漲。TradFit 與客戶及協作（共創）夥伴企業等攜手，從各個層面持續進行共創與變革，以「三方受益（三方よし）」的方式解決日本各行業所面臨的重大課題。</p>

        <p>TradFit 專門為觀光、飯店、日式旅館、不動產、醫院、護理設施、全國各地的地方事業者、行政自治體等開發和運營 AI 及軟體等。</p>

        <p>TradFit 的優勢在於與各行業的客戶及國內外企業等建立夥伴關係，通過共創解決單一企業無法解決的各種課題，並加速制定能推動業務發展的攻守兼備的知識產權戰略、獲取知識產權，以及構建面向國內外拓展的專利組合。</p>

        <p>此次，我們迎來了在包括日本在內的國際市場、各行業及產業中面對複雜課題的領導者百瀬裕規氏擔任執行顧問，以進一步推動經營體制的強化和業務擴展的提升。</p>

        <h3><strong>■ TradFit 執行顧問 百瀬裕規 致辭</strong></h3>
        <p>我是此次就任 TradFit 執行顧問的百瀬。通過前職的緣分介紹認識了戶田社長，特別是對於以「三方受益（三方よし）」解決日本社會課題的理念產生了強烈共鳴。</p>

        <p>對於以「三方受益（三方よし）」重視與國內外企業的夥伴關係，嘗試與各公司聯手解決單一企業無法解決的各種課題，並實現更美好社會的這一想法，我感受到了巨大的可能性和社會意義。</p>

        <p>我長期投身於金融領域，致力於為各種產業和企業的發展做出貢獻，並為實現更美好的社會傾注心力。</p>

        <p>我將以所積累的人脈和網絡、對金融及產業的見解、以及作為企業經營者的職業生涯為基礎，全力支援 TradFit 實現其理念，並為 TradFit 今後的飛躍式發展提供支持。</p>

        <h3><strong>■ TradFit 執行顧問 百瀬裕規 簡歷</strong></h3>
        <p>1985年 大阪大學經濟學部畢業後，進入野村證券株式會社。<br>
        2008年 該公司執行董事大阪支店長。<br>
        2013年 該公司常務董事大阪駐在兼大阪支店長。<br>
        2017年 該公司專務董事大阪駐在。<br>
        2019年 野村綜合研究所株式會社董事副會長。<br>
        2025年 就任 TradFit 株式會社執行顧問。</p>

        <h3><strong>■ TradFit 代表取締役 戸田 良樹 致辭</strong></h3>
        <p>此次，為實現解決日本各行業所面臨重大課題的目標，並進一步強化經營體制、提升業務擴展，我們邀請百瀬先生就任 TradFit 的執行顧問。</p>

        <p>百瀬先生曾在野村集團擔任野村證券專務董事大阪駐在、野村綜合研究所副會長，目前擔任世界知名大型 PE 基金的共同會長。</p>

        <p>在野村證券期間，百瀬先生在大阪和東京從事投資銀行業務長達 27 年，擁有處理眾多日本企業 M&A、投資、融資案件的豐富經驗和實績。</p>

        <p>在推動 TradFit 經營體制強化和業務擴展提升等事業發展方面，我們將向作為經營領導者在廣泛產業和行業中建立了實績、經驗和人脈網絡的百瀬先生學習很多，並決心挑戰 TradFit 今後的飛躍式成長。</p>

        <h3><strong>■ 關於 TradFit 開展的服務</strong></h3>
        <p>TradFit 開展「利用生成式 AI、語音 AI、IoT、機器人技術、生物識別技術等，為觀光、飯店、日式旅館、不動產、醫院、護理設施、全國各地的地方事業者、行政自治體等提供收益性改善等服務的平台」業務。我們致力於解決人力短缺問題等重大社會課題，並提供相關服務。</p>

        <p>我們已完成與自主行走機器人的系統聯動，與各行業的客戶及國內外協作（共創）夥伴企業等攜手，共同解決各種課題，並加速制定能推動業務發展的攻守兼備的知識產權戰略、獲取知識產權，以及構建面向國內外拓展的專利組合。</p>

        <p>通過 TradFit 的服務平台，事業者可以通過提高業務效率和補充人力短缺的服務，實現成本削減和銷售增長，並且由於我們與國內外協作（共創）夥伴共同推進開放式創新，因此還具有開展新業務的可能性。</p>

        <p>TradFit 將與國內外協作（共創）夥伴企業攜手，繼續解決日本和全球企業每天面臨的社會課題，並以成為引領可持續未來的新社會基礎設施為目標。</p>

        <h3><strong>■ 關於 TradFit</strong></h3>
        <p>【公司名稱】TradFit 株式會社<br>
        【所在地】東京都千代田區丸之內 1-6-5 丸之內北口大樓 9F<br>
        【代表者】代表取締役 戸田 良樹<br>
        【成立】2017年8月<br>
        【資本金】1億日圓<br>
        【網站】<a target="_blank" rel="nofollow ugc noopener" href="https://company.tradfit.com">https://company.tradfit.com</a></p>

        <h3><strong>■ 關於本新聞的諮詢</strong></h3>
        <p>TradFit 株式會社<br>
        E-mail:info@tradift.com</p>

        <p><strong>■ 關於本新聞的媒體諮詢</strong><br>
        E-mail:contact@tradfit.com</p>

        <p><strong>■ 文章連結（PRTIMES）</strong><br>
        <a target="_blank" rel="nofollow ugc noopener" href="https://prtimes.jp/main/html/rd/p/000000187.000033116.html">https://prtimes.jp/main/html/rd/p/000000187.000033116.html</a></p>
      `
    },
    {
      date: '2025.12.02',
      category: '案例研究 / 發布',
      title: '獲 Travel Voice 報導。TradFit 與 NEC Networks & System Integration Corporation 簽署經銷協議，強化 AI 語音服務「Hospitalia」支援體系',
      content: `<p>為住宿設施提供數位解決方案的 TradFit 株式會社，正與 NEC Networks & System Integration Corporation 就飯店業 AI 語音服務「Hospitalia」進行經銷協議。這將強化對全日本飯店的銷售和支援體系。</p>
  <img loading="lazy" width="800" height="288" src="https://company.tradfit.com/wp-content/uploads/2025/12/thumb_w800_a125cc1c-13b3-4248-bb70-2ac09dff0d5f.jpeg" alt="" class="w-full h-auto rounded-lg my-6" />
  <p>TradFit 是日本首家獲得 Amazon 認證為「Alexa Smart Properties for Hospitality」解決方案供應商的公司，也是首家針對飯店業開發並部署結合 Amazon AI 的「Hospitalia」的企業。</p>
  <p>Hospitalia 是基於 Amazon AI 助理 Alexa 的飯店業服務，透過智慧顯示器上的語音、文字、圖片和影片來支援使用者。</p>
  <p><strong>■ 連結</strong><br><a href="https://www.travelvoice.jp/20251202-158844" target="_blank" rel="noreferrer noopener">https://www.travelvoice.jp/20251202-158844</a></p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>
  <p><strong>■ 本案媒體相關諮詢</strong><br>E-mail:contact@tradfit.com</p>`
    },
    {
      date: '2025.11.27',
      category: '案例研究 / 發布',
      title: 'TradFit 強化全國銷售與支援體系。與商業夥伴 (*) 共同向全國擴展 Amazon Echo 企業版飯店客房服務「Hospitalia」',
      content: `<p><span style="color: #546e7a;">~與各商業夥伴 (*) 強力支援飯店業加速 AI 應用與數位轉型 (DX)~</span></p>
  <p><strong>TradFit 株式會社（總部：東京都千代田區，以下簡稱「TradFit」）正與 NEC Networks & System Integration Corporation (*)（總部：東京都港區，以下簡稱「NEC Networks & System Integration」）就本公司為飯店業提供的「Hospitalia」服務銷售進行經銷協議。</strong></p>
  <p><strong>透過此協議，「Hospitalia」現在可以為全日本的飯店提供比以往更廣泛的銷售和支援體系。</strong></p>
  <p><strong>飯店業對加速數位轉型 (DX) 的期望很高，特別是在 AI 領域，我們致力於繼續成為客戶的好夥伴，透過與他們一起改革來建立新時代。</strong></p>
  <p><strong>■ 本產品「Hospitalia」的特點</strong><br>TradFit 是日本唯一獲得 Amazon 認證為 Alexa Smart Properties for Hospitality 解決方案供應商的新創公司，合作開發並部署結合 Amazon AI 的飯店業「Hospitalia」服務。</p>
  <img src="https://prcdn.freetls.fastly.net/release_image/33116/186/33116-186-e9cb6a13abe1491540e01c87160e82ff-850x446.jpg?width=1950&height=1350&quality=85&format=jpeg&auto=webp&fit=bounds&bg-color=fff" alt="" class="w-full h-auto rounded-lg my-6" />
  <p>我們經營「利用生成式 AI、語音 AI、IoT 和機器人等技術支援飯店業進一步提升獲利能力的服務平台業務」。我們主要推動解決飯店業勞動力短缺等重大社會問題並提供服務。</p>
  <p><strong>■ TradFit 的優勢與特點</strong><br>TradFit 的優勢在於擁有能夠解決飯店業面臨問題的專利組合，並提供適合飯店業工作方式的服務。</p>
  <p>透過服務平台，TradFit 為飯店業提供服務，以提升國內外住宿客人的體驗價值，處理各種詢問和訂單（多語言支援），減輕飯店員工的營運負擔，並補充勞動力短缺。</p>
  <p><strong>■ 關於 TradFit</strong><br>【公司名稱】TradFit 株式會社<br>【所在地】東京都千代田區丸之內 1-6-5 丸之內北口大樓 9F<br>【代表人】代表取締役 戸田 良樹<br>【成立】2017年8月<br>【資本金】1億日圓<br>【服務網站】<a href="https://hospitalia.jp/" target="_blank" rel="noreferrer noopener">https://hospitalia.jp</a><br>【企業網站】<a href="https://company.tradfit.com/" target="_blank" rel="noreferrer noopener">https://company.tradfit.com/</a></p>
  <img src="https://prcdn.freetls.fastly.net/release_image/33116/186/33116-186-e659118fc5c31b18ebeff2c7ce8768ab-850x306.jpg?width=1950&height=1350&quality=85&format=jpeg&auto=webp&fit=bounds&bg-color=fff" alt="" class="w-full h-auto rounded-lg my-6" />
  <p><strong>■ 連結</strong><br><a href="https://prtimes.jp/main/html/rd/p/000000186.000033116.html" target="_blank" rel="noreferrer noopener">https://prtimes.jp/main/html/rd/p/000000186.000033116.html</a></p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>
  <p><strong>■ 本案媒體相關諮詢</strong><br>E-mail:contact@tradfit.com</p>`
    },
    {
      date: '2025.11.21',
      category: '案例研究 / 發布',
      title: '透過 Alexa Smart Properties 支援觀光、住宿、醫療產業及地方政府的營運效率與生產力提升 - 貢獻於解決因入境旅遊增加和人口減少導致的勞動力短缺與多語言支援問題',
      content: `<img src="https://dhhmpfovkf2ub.cloudfront.net/content/dam/alexa/ja-jp/asp/success-stories/tradfit/tradfit_main.jpg" alt="TradFit株式会社 代表取締役 戸田　良樹 氏" class="w-full h-auto rounded-lg my-6" />
      <h5><strong>利用 Alexa Smart Properties 的服務特點</strong></h5>
<ul>
<li>透過住宿設施的語音訂單接收，將撥打至櫃台的電話減少一半</li>
<li>透過多語言支援流暢回覆住宿客人，貢獻於入境需求</li>
<li>透過強大的安全性，即使在不特定多數人使用的環境中也能安全操作</li>
</ul>

<p><strong>公司名稱：</strong> TradFit 株式會社</p>
<p><strong>行業：</strong> 利用雲端 AI 建構與營運語音數據平台</p>
<p><strong>成立：</strong> 2017年8月</p>
<p><strong>所在地：</strong> 100-0005 東京都千代田區丸之內 1-6-5 丸之內北口大樓 9F</p>
<p><strong>網站：</strong> <a href="https://company.tradfit.com/" target="_blank">https://company.tradfit.com/</a></p>

<p><a href="https://ds6yc8t7pnx74.cloudfront.net/content/dam/alexa/ja-jp/asp/success-stories/pdf/AmazonAlexa_SP_TradFit.pdf" target="_blank" class="inline-block px-6 py-3 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors">下載 PDF 版本</a></p>

<h3><strong>"Hospitalia" - 解決住宿設施、醫療/護理現場及地方政府問題的關鍵</strong></h3>

<p>TradFit 旨在透過利用語音、生成式 AI、機器人和 IoT 技術，提供能夠實現全球人們更美好生活的服務，來解決觀光、住宿、醫療產業及地方政府的社會問題。TradFit 的語音 AI 解決方案不僅有助於提升營運效率，還有助於解決社會問題。TradFit 基於 Amazon Alexa 開發了一項名為「Hospitalia」的服務，適用於飯店業（包括住宿設施、醫療護理和養老護理）以及地方政府。它透過語音、智慧顯示器上的文字、圖片和影片支援客戶體驗改善和員工營運。</p>

<p>代表取締役 戸田 良樹 強調：「TradFit 自成立以來一直專注於智慧財產權戰略。我們的最大優勢是利用智慧財產權進行『三方受益（三方よし）』的業務開發。我們擁有多項商業模式專利和基礎專利，這些專利不僅在觀光和住宿業，還在醫療業和地方政府中直接帶來銷售提升和成本降低。我們透過這種智慧財產權戰略徹底區分自己。在此基礎上，我們與客戶和合作夥伴一起推進三方受益，涵蓋解決日本面臨的社會問題、解決各行業客戶的問題以及我們自身的成長。」</p>

<p>董事兼 CTO 伊藤 智春，曾獲選為 Alexa Champion，以表彰在 Alexa 開發者社群中特別活躍並做出貢獻的開發者和工程師，他強調：「TradFit 持續致力於技術開發以改善對話體驗。TradFit 的另一個巨大優勢是能夠獲取以前無法獲得的獨特數據，並通過結合對話專有技術和因業態而異的住宿設施特徵來設計符合各種模式的對話。我們也繼續專注於利用生成式 AI 技術提高語音識別準確率。」</p>

<img src="https://dhhmpfovkf2ub.cloudfront.net/content/dam/alexa/ja-jp/asp/success-stories/tradfit/tradfit_003.jpg" alt="TradFit Co., Ltd. Director CTO Tomoharu Ito" class="w-full h-auto rounded-lg my-6" />
<p class="text-sm text-gray-600">TradFit 株式會社 董事 CTO 伊藤 智春</p>

<h3><strong>利用語音與生成式 AI 解決住宿業面臨的問題</strong></h3>

<p>近年來，住宿業出現了各種問題。住宿業要求員工具備高水準的客戶服務技能，並且必須全天候回應客人的需求。此外，隨著入境需求的擴大，為了迎接來自海外的客人，多語言支援成為必需。在這種背景下，工作量增加，長期的勞動力短缺也成為一個問題。勞動力成本也呈上升趨勢，提高獲利能力的營運效率已成為當務之急。</p>

<p>「住宿業面臨許多問題，例如因入境旅遊增加導致的勞動力短缺和多語言支援。當 TradFit 開發結合生成式 AI 和語音 AI 的商業用 Alexa 時，我們思考了『哪一個行業最能透過我們的服務貢獻於解決社會和行業面臨的問題』，我們訪問了行業現場，並對國內外旅客進行了生動的訪談。經過反覆試驗，我們決定首先專注於住宿業。從那時起，我們一直以 Hospitalia 品牌提供語音 × AI 解決方案，以解決住宿業面臨的問題。」（戸田）</p>

<h3><strong>透過 Alexa Smart Properties 應對入境旅遊並將櫃台來電減少一半</strong></h3>

<p>Alexa Smart Properties 是一項為住宿設施、老年護理設施和地方政府量身打造的服務，自 2023 年 12 月起在日本推出。TradFit 與 Amazon 簽約成為 Alexa Smart Properties for Hospitality 的解決方案供應商，客製化主畫面和通知功能，並構建獨特的客製化技能，以提供更能滿足住宿設施需求的服務。</p>

<p>Alexa Smart Properties 的主要優點之一是，得益於強大的安全性，即使在不特定多數人使用的環境中也能安全操作。伊藤表示：「有了 Alexa Smart Properties，使用者的語音紀錄和語音活動受到保護，隱私和安全性都得以實現，創造了一個可以安心使用的環境。」</p>

<p>在小田急世紀南塔飯店，所有 375 間客房都安裝了相容 Alexa Smart Properties 的 Echo Show。在實現應對入境需求的多語言支援的同時，也實現了客人租借設備等訂單的語音接收。在平均每天約 30 次對 Alexa 的詢問中，只有 10 次轉向電話通話 (*1)。在龍宮城 Spa 飯店三日月，所有 479 間客房都安裝了 Alexa Smart Properties。除了使用相容 Alexa Smart Properties 的 Echo Show 提供飯店內設施和活動指引外，透過進一步強化語音功能，櫃台來電率從 48% 降低到 20% (*2)。</p>

<h3><strong>基於 Alexa Smart Properties 擴展服務，並展望進一步的生成式 AI 應用</strong></h3>

<p>未來，TradFit 將進一步擴展利用 Alexa Smart Properties 的服務。</p>

<p>伊藤表達了他的熱情：「未來，我們希望透過 Alexa Smart Properties 向包括住宿業、醫療業和地方政府在內的各種企業和組織提供由 TradFit 客製化的高附加價值服務。透過這項舉措，我們將貢獻於解決日本飯店業的問題並貢獻於解決社會問題。」</p>

<img src="https://dhhmpfovkf2ub.cloudfront.net/content/dam/alexa/ja-jp/asp/success-stories/tradfit/tradfit_002.JPG" alt="TradFit Co., Ltd. Representative Director Yoshiki Toda" class="w-full h-auto rounded-lg my-6" />
<p class="text-sm text-gray-600">TradFit 株式會社 代表取締役 戸田 良樹<br>拍攝地點：WeWork 丸之內北口</p>

<p>隨著未來的業務擴展，TradFit 旨在實現一個人人都能健康生活的「幸福（well-being）」社會。「在立足日本的同時，我們將向住宿業、醫療業和地方政府等多個方向發展業務，致力於解決少子高齡化、人口減少和獨居等許多問題。此外，考慮到現狀和未來前景，我們感到被稱為問題先進國的日本社會面臨的問題也將在全球發生。我們相信源自日本的服務將在全球發揮作用，未來我們將向海外擴展服務，提供身心豐富的生活，」戸田表達了他的熱情。</p>

<h5><strong>SP 簡介</strong></h5>

<p>我們的使命是「透過本公司提供的服務為世界各地的人們提供更好的生活」，並開發語音 AI 解決方案。近年來，我們一直在提供「Hospitalia」，這是一項基於 Alexa 企業服務「Alexa Smart Properties」並加入我們自身技術為日本飯店業和地方政府進行在地化的服務，並一直在建立實績。</p>

<p class="text-sm text-gray-600">*1 數據收集期間：2025年2月。透過計算 Alexa 回覆中導向電話通話的次數來衡量減少櫃台詢問的效果。</p>
<p class="text-sm text-gray-600">*2 來電率：每日住宿組數 ÷ 櫃台來電數 = 來電率。此次描述的是測量期間來電率的平均值。<br>安裝前測量期間：2023年12月3日至2023年12月17日。<br>安裝後測量期間：2024年1月16日至2024年2月15日。</p>

<p class="text-sm text-gray-600 mt-4">*採訪期間：2025年5月</p>
<p class="text-sm text-gray-600">*所有描述（職位、數字、專有名詞等）均為採訪時的資訊。</p>

<p class="mt-6"><strong>■ 原始文章連結</strong><br><a href="https://developer.amazon.com/ja-JP/blogs/alexa/alexa-smart-properties/tradfit" target="_blank" rel="noreferrer noopener">https://developer.amazon.com/ja-JP/blogs/alexa/alexa-smart-properties/tradfit</a></p>

<p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>

<p><strong>■ 本案媒體相關諮詢</strong><br>E-mail:contact@tradfit.com</p>`
    },
    {
      date: '2025.07.28',
      category: '案例研究 / 發布',
      title: '我們取得的專利獲 Travel Voice 報導。TradFit 取得整合、分析並生成各種數據，實現服務使用狀況視覺化的「智慧 BI 工具」基礎專利',
      content: `<p>TradFit 已取得整合、分析並生成各種數據，使服務使用狀況視覺化成為可能的「智慧 BI 工具」的基礎專利。</p>
  <p>這項專利技術使得包括飯店業在內的各行各業都能加速數據驅動管理。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.07.24',
      category: '案例研究 / 發布',
      title: '世界首創！整合所有數據並將服務使用狀況視覺化的商業智慧工具！取得加速數據驅動管理的基礎專利（商業模式專利）「智慧 BI 工具」',
      content: `<p>TradFit 株式會社已取得整合各種數據並將服務使用狀況視覺化的商業智慧工具的基礎專利（商業模式專利）「智慧 BI 工具」，這是世界首創。</p>
  <p>這項創新技術使企業能夠加速數據驅動管理並做出更高效的決策。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.07.23',
      category: '案例研究 / 發布',
      title: '獲 Travel Voice 報導。AI 語音服務 TradFit 在度假租賃智慧家庭設施開始使用 Amazon Alexa 提供服務',
      content: `<p>提供 AI 語音服務的 TradFit，已開始在度假租賃智慧家庭設施利用 Amazon Alexa 提供服務。</p>
  <p>這項舉措實現了度假租賃設施住宿體驗的改善和高效的設施運營。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.07.15',
      category: '案例研究 / 發布',
      title: '日本首創，在南青山的度假租賃/住宅引進配備住宿支援 AI 的 Amazon Echo，開始提供服務',
      content: `<p>TradFit 株式會社已在南青山的度假租賃/住宅引進配備住宿支援 AI 的 Amazon Echo，這是日本首創，並開始提供服務。</p>
  <p>這項先進的舉措為客人提供了更舒適、便捷的住宿體驗。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.06.24',
      category: '案例研究 / 發布',
      title: '我們取得的專利獲 Travel Voice 報導。AI 音箱 TradFit 取得預訂期間介紹下一家住宿的模式專利',
      content: `<p>提供 AI 音箱的 TradFit，已取得在住宿預訂期間介紹下一家住宿設施的商業模式專利。</p>
  <p>這項技術大幅提升了旅客的便利性，實現了無縫的旅行體驗。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.06.19',
      category: '案例研究 / 發布',
      title: '獲清晰解說世界 IP 資訊的媒體 IP Media +Vision 報導',
      content: `<p>TradFit 株式會社的舉措被清晰解說世界 IP 資訊的媒體「IP Media +Vision」報導。</p>
  <p>我們創新的專利技術和對飯店業的貢獻受到了評價。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.06.19',
      category: '案例研究 / 發布',
      title: '世界首創！如果預訂住宿的人需要，自動介紹住宿設施！取得商業模式專利（基礎專利技術）「下一家住宿推薦 3」',
      content: `<p>TradFit 株式會社已取得商業模式專利（基礎專利技術）「下一家住宿推薦 3」，如果預訂住宿的人需要，它會自動介紹住宿設施，這是世界首創。</p>
  <p>這項創新技術使旅客在選擇下一個目的地的住宿時更加輕鬆方便。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.06.06',
      category: '案例研究 / 發布',
      title: '群馬縣首家！Hotel Sanderson 引進了 Nippon Pascom 商業夥伴 TradFit 提供的生成式 AI Hospitalia (Amazon ASP for Hospitality)',
      content: `<p>作為群馬縣的首項舉措，Hotel Sanderson 引進了 Nippon Pascom 商業夥伴 TradFit 提供的生成式 AI「Hospitalia (Amazon ASP for Hospitality)」。</p>
  <p>這項引進實現了飯店服務品質和營運效率的提升。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.05.09',
      category: '案例研究 / 發布',
      title: '從生成式 AI 音箱「Hospitalia」引進案例中學到，飯店業解決勞動力短缺問題的措施是什麼？',
      content: `<p>透過生成式 AI 音箱「Hospitalia」的引進案例，我們介紹飯店業解決所面臨的勞動力短缺問題的具體方法。</p>
  <p>我們詳細說明實際引進設施的成果和有效的使用方法。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.04.04',
      category: '案例研究 / 發布',
      title: '住宿設施將如何隨著生成式 AI 音箱的使用而改變？詢問引進 TradFit「Hospitalia」的設施從客戶體驗到後勤的變化',
      content: `<p>隨著生成式 AI 音箱的使用，住宿設施將如何改變？我們詳細詢問了引進 TradFit「Hospitalia」的設施，從客戶體驗到後勤的變化。</p>
  <p>我們介紹實際現場的效果和未來展望。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.03.27',
      category: '案例研究 / 發布',
      title: 'AI 語音服務 TradFit 與智慧家庭引進支援公司簽署策略聯盟，利用 AI 和 IoT 技術推動解決勞動力短缺問題',
      content: `<p>提供 AI 語音服務的 TradFit 與一家智慧家庭引進支援公司簽署了策略聯盟。</p>
  <p>透過利用 AI 和 IoT 技術，我們將推動解決整個行業的勞動力短缺問題。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.03.27',
      category: '案例研究 / 發布',
      title: 'TradFit 宣布與 ao. 建立全面業務聯盟！共同推動觀光、住宿、醫療、地方政府等的補助金和補貼支援！',
      content: `<p>TradFit 株式會社宣布與 ao. 締結全面業務聯盟。</p>
  <p>我們將共同推動對觀光、住宿、醫療、地方政府等的各種補助金和補貼的支援，並為整個行業的發展做出貢獻。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.03.26',
      category: '案例研究 / 發布',
      title: 'TradFit × Sanwa Telem 智慧家庭市場的創新！宣布全面業務聯盟',
      content: `<p>TradFit 株式會社與 Sanwa Telem 宣布締結全面業務聯盟，旨在實現智慧家庭市場的創新。</p>
  <p>利用兩家公司的優勢，我們旨在實現更舒適、便捷的智慧家庭環境。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.03.21',
      category: '案例研究 / 發布',
      title: 'AI 語音服務 TradFit 加入 Airbnb 合作夥伴計畫，支援註冊設施獲利能力提升',
      content: `<p>提供 AI 語音服務的 TradFit 已加入 Airbnb 合作夥伴計畫。</p>
  <p>我們支援註冊設施獲利能力提升，並實現更高品質的服務提供。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.03.19',
      category: '案例研究 / 發布',
      title: 'TradFit 加入 Airbnb Partners ~與 Airbnb 合作推動住宿業生成式 AI 應用~',
      content: `<p>TradFit 株式會社已加入 Airbnb Partners。</p>
  <p>透過與 Airbnb 合作並推動住宿業生成式 AI 應用，我們推動整個行業的數位化。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.02.17',
      category: '案例研究 / 發布',
      title: '【新創公司專題】TradFit 建立安全的語音數據平台',
      content: `<p>作為新創公司專題，介紹了 TradFit 株式會社建立安全語音數據平台的努力。</p>
  <p>我們詳細解釋兼顧安全與便利的創新平台。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.02.04',
      category: '案例研究 / 發布',
      title: '京都旅館引進住宿設置用生成式 AI 音箱，TradFit「Hospitalia」能做什麼？',
      content: `<p>京都的一家旅館引進了住宿設置用生成式 AI 音箱。</p>
  <p>我們透過實際引進案例詳細介紹 TradFit「Hospitalia」能做什麼。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2025.02.03',
      category: '案例研究 / 發布',
      title: '企業和地方政府用的「Amazon Alexa」將為問題驅動的日本社會帶來什麼？',
      content: `<p>我們思考企業和地方政府用的「Amazon Alexa」將為問題驅動的日本社會帶來什麼轉變。</p>
  <p>AI 技術的應用有望解決各種社會問題。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.11.05',
      category: '案例研究 / 發布',
      title: 'AI 語音服務 TradFit 取得透過連結設施管理系統和使用服務自動進行個人化回覆的專利',
      content: `<p>提供 AI 語音服務的 TradFit，已取得透過連結設施管理系統和使用服務自動進行個人化回覆的專利。</p>
  <p>這項技術實現了更個人化的服務提供。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.11.01',
      category: '案例研究 / 發布',
      title: '世界首創！連結飯店、日式旅館、醫院、護理、房地產、辦公大樓等所有管理系統與用戶使用服務，自動提供個人化服務！取得商業模式專利「智慧系統連結 2」',
      content: `<p>TradFit 株式會社已取得連結飯店、日式旅館、醫院、護理、房地產、辦公大樓等所有管理系統與用戶使用服務，並自動提供個人化服務的商業模式專利「智慧系統連結 2」，這是世界首創。</p>
  <p>這項技術有望提高整個住宿業的服務品質。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.10.09',
      category: '案例研究 / 發布',
      title: 'AI 語音服務 TradFit 取得透過與住宿管理系統連結，優化個別住宿客人需求回覆的基礎專利',
      content: `<p>提供 AI 語音服務的 TradFit，已取得優化個別住宿客人需求回覆的基礎專利。</p>
  <p>透過與住宿管理系統的連結，實現更個人化的服務提供。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.10.06',
      category: '案例研究 / 發布',
      title: '世界首創！與飯店、日式旅館、度假租賃、豪華露營等住宿設施的核心管理系統 (PMS) 和客人使用服務連結，自動提供個人化服務！取得商業模式專利「智慧系統連結」',
      content: `<p>TradFit 株式會社已取得商業模式專利「智慧系統連結」，該專利連結飯店、日式旅館、度假租賃和豪華露營等住宿設施的核心管理系統 (PMS) 和客人使用服務，並自動提供個人化服務，這是世界首創。</p>
  <p>這項技術有望提高整個住宿業的服務品質。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.09.10',
      category: '案例研究 / 發布',
      title: '住宿設置 AI 服務 TradFit 取得以文字回覆語音請求的專利，對客人和老年人更易於理解',
      content: `<p>提供住宿設置 AI 服務的 TradFit，已取得以文字回覆語音請求的專利。</p>
  <p>實現了對客人和老年人更易於理解的服務提供。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.09.10',
      category: '案例研究 / 發布',
      title: '世界首創！回覆語音請求的功能，即使在嘈雜環境中也能清楚引導國內外客人、老年人和患者！取得基礎專利「智慧引導」',
      content: `<p>TradFit 株式會社已取得基礎專利「智慧引導」，該功能可回覆客人的語音請求，即使在嘈雜環境中也能清楚引導國內外客人、老年人和患者，這是世界首創。</p>
  <p>這項技術使我們能夠為更多人提供舒適的服務。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.08.20',
      category: '案例研究 / 發布',
      title: '住宿設置 AI 服務 TradFit 與韓國 IT 投資公司合作，推動利用技術的「健康旅遊」',
      content: `<p>提供住宿設置 AI 服務的 TradFit 與韓國 IT 投資公司合作，推動利用技術的「健康旅遊」。</p>
  <p>我們旨在創造融合健康與旅遊的新旅行體驗。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.07.17',
      category: '案例研究 / 發布',
      title: '住宿設置 AI 服務 TradFit 與韓國 IT 投資公司合作，推動利用技術的「健康旅遊」',
      content: `<p>提供住宿設置 AI 服務的 TradFit 與韓國 IT 投資公司合作，推動利用技術的「健康旅遊」。</p>
  <p>我們旨在創造融合健康與旅遊的新旅行體驗。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.07.17',
      category: '案例研究 / 發布',
      title: 'MILESEUM 與 TradFit 針對下一代先進產業 DX 領域（利用 AI、IoT、機器人、生物識別門鎖、電子看板等實現無人化/省力化）、健康旅遊等締結全面業務聯盟',
      content: `<p>MILESEUM 與 TradFit 已針對下一代先進產業 DX 領域（利用 AI、IoT、機器人、生物識別門鎖、電子看板等實現無人化/省力化）、健康旅遊等締結全面業務聯盟。</p>
  <p>我們將匯集兩家公司的技術和專有知識，推動產業創新。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.02.13',
      category: '案例研究 / 發布',
      title: 'AI 音箱 TradFit 取得元宇宙空間建立平台專利，只需身份驗證即可讓任何人開店',
      content: `<p>提供 AI 音箱的 TradFit 已取得元宇宙空間建立平台專利。</p>
  <p>我們實現了一個只需身份驗證即可讓任何人開店的創新平台。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.02.07',
      category: '案例研究 / 發布',
      title: '住宿設置 AI 音箱 TradFit 啟動新服務，利用智慧型手機獲取的資訊完成目的地最佳飯店的預訂',
      content: `<p>提供住宿設置 AI 音箱的 TradFit 已啟動一項新服務，利用智慧型手機獲取的資訊完成目的地最佳飯店的預訂。</p>
  <p>這是一項大幅提升旅客便利性的創新服務。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.02.06',
      category: '案例研究 / 發布',
      title: '世界首創！元宇宙空間建立平台！取得基礎專利「智慧元宇宙」',
      content: `<p>TradFit 株式會社已取得元宇宙空間建立平台的基礎專利「智慧元宇宙」，這是世界首創。</p>
  <p>這項創新技術使得新數位空間的建立成為可能。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.02.01',
      category: '案例研究 / 發布',
      title: '住宿設置 AI 音箱 TradFit 取得可輕鬆管理客人請求的 UI 專利，支援營運改善',
      content: `<p>提供住宿設置 AI 音箱的 TradFit 已取得可輕鬆管理客人請求的 UI 專利。</p>
  <p>我們支援營運改善並實現高效的設施管理。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.01.31',
      category: '案例研究 / 發布',
      title: '世界首創！利用客人智慧型手機等獲取的目的地資訊，自動介紹住宿設施！取得基礎專利「下一家住宿推薦 2」',
      content: `<p>TradFit 株式會社已取得基礎專利「下一家住宿推薦 2」，利用客人智慧型手機等獲取的目的地資訊自動介紹住宿設施，這是世界首創。</p>
  <p>我們支援旅客選擇下一個目的地的住宿。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.01.30',
      category: '案例研究 / 發布',
      title: '住宿設置 AI 音箱 TradFit 取得透過語音個別識別客人的新技術專利',
      content: `<p>提供住宿設置 AI 音箱的 TradFit 已取得透過語音個別識別客人的新技術專利。</p>
  <p>更個人化的服務提供成為可能。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.01.30',
      category: '案例研究 / 發布',
      title: '世界首創！取得透過簡單操作即可清楚管理客人請求的革命性 UI「智慧請求管理 UI」專利',
      content: `<p>TradFit 株式會社已取得革命性 UI「智慧請求管理 UI」的專利，該 UI 透過簡單操作即可清楚管理客人請求，這是世界首創。</p>
  <p>大幅提升設施員工的營運效率。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.01.24',
      category: '案例研究 / 發布',
      title: 'TradFit 在日本之後，於菲律賓取得利用 AI 音箱優化飯店客房溫度的專利',
      content: `<p>TradFit 繼日本之後，於菲律賓取得了利用 AI 音箱優化飯店客房溫度的專利。</p>
  <p>我們加速全球擴展，旨在為世界各地的住宿設置提供服務。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.01.24',
      category: '案例研究 / 發布',
      title: '世界首創！自動判斷是哪位客人提出的請求！取得基礎專利「智慧音箱判斷」',
      content: `<p>TradFit 株式會社已取得基礎專利「智慧音箱判斷」，可自動判斷是哪位客人提出的請求，這是世界首創。</p>
  <p>更精確且高效的服務提供成為可能。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2024.01.22',
      category: '案例研究 / 發布',
      title: '世界首創！為客人自動優化室溫和照明等房間環境！在菲律賓也取得基礎專利「房間智慧控制」',
      content: `<p>TradFit 株式會社在菲律賓也取得了基礎專利「房間智慧控制」，可為客人自動優化室溫和照明等房間環境，這是世界首創。</p>
  <p>我們透過獲取國際專利加速全球擴展。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.12.11',
      category: '案例研究 / 發布',
      title: '龍宮城 Spa 飯店三日月在所有客房引進 AI 音箱，結合生成式 AI 並試行智慧客房',
      content: `<p>龍宮城 Spa 飯店三日月已在所有客房引進 AI 音箱。</p>
  <p>結合生成式 AI 並試行智慧客房，我們提供尖端的飯店體驗。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.12.05',
      category: '案例研究 / 發布',
      title: '龍宮城 Spa 飯店三日月的富士見亭和龍宮亭所有客房引進 AI 音箱',
      content: `<p>我們已在龍宮城 Spa 飯店三日月的富士見亭和龍宮亭所有客房引進 AI 音箱。</p>
  <p>我們為客人提供更舒適、便捷的住宿體驗。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.12.04',
      category: '案例研究 / 發布',
      title: '北海道首創！TradFit 在東急飯店及度假村「札幌 Stream Hotel」引進 Alexa Smart Properties for Hospitality',
      content: `<p>作為北海道的首項舉措，TradFit 在東急飯店及度假村「札幌 Stream Hotel」引進了 Alexa Smart Properties for Hospitality。</p>
  <p>我們在北海道開始擴展服務。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.12.04',
      category: '案例研究 / 發布',
      title: '日本首創 / 行業首創！TradFit 獲得認證，成為專門針對飯店等所有住宿設置的 Amazon「Alexa Smart Properties」解決方案供應商',
      content: `<p>作為日本首創和行業首創的成就，TradFit 已獲得認證，成為專門針對飯店等所有住宿設置的 Amazon「Alexa Smart Properties」解決方案供應商。</p>
  <p>這項認證使得提供更高品質的服務成為可能。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.07.29',
      category: '案例研究 / 發布',
      title: '精通 UX 和 IoT 跨領域的 UX 設計師私市 瑞希，就任 TradFit 株式會社 CDO',
      content: `<p>精通 UX 和 IoT 跨領域的 UX 設計師私市 瑞希，已就任 TradFit 株式會社的 CDO (Chief Design Officer)。</p>
  <p>我們旨在提供卓越的使用者體驗。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.05.06',
      category: '案例研究 / 發布',
      title: '椎名 茂 就任 TradFit 顧問。強化經營策略規劃、全球擴展策略、利用 AI 的 DX 策略等',
      content: `<p>椎名 茂 已就任 TradFit 顧問。</p>
  <p>我們將強化經營策略規劃、全球擴展策略、利用 AI 的 DX 策略等，並旨在進一步成長。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.04.17',
      category: '案例研究 / 發布',
      title: '住宿設置 AI 音箱 TradFit 啟動利用「ChatGPT」的客人回覆服務，自動判斷語言以支援多語言',
      content: `<p>提供住宿設置 AI 音箱的 TradFit，已啟動利用「ChatGPT」的客人回覆服務。</p>
  <p>自動判斷語言並實現多語言支援。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.04.15',
      category: '案例研究 / 發布',
      title: 'TradFit 提供日本首個「ChatGPT 自動回覆服務」測試版',
      content: `<p>TradFit 株式會社已開始提供日本首個「ChatGPT 自動回覆服務」測試版。</p>
  <p>這是一項利用尖端 AI 技術的創新服務。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.03.06',
      category: '媒體報導 / 發布',
      title: '住宿設置 AI 音箱 TradFit 歡迎亞洲首位 Amazon Alexa Champion 伊藤先生擔任 CTO',
      content: `<p>提供住宿設置 AI 音箱的 TradFit，已歡迎亞洲首位 Amazon Alexa Champion 伊藤先生擔任技術長 (CTO)。</p>
  <p>我們旨在進一步強化我們的技術能力。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.02.21',
      category: '案例研究 / 發布',
      title: '住宿設置 AI 音箱 TradFit 開發自動優化房間環境技術，依據客人屬性選擇控制模式',
      content: `<p>提供住宿設置 AI 音箱的 TradFit，已開發自動優化房間環境技術。</p>
  <p>依據客人屬性選擇控制模式，提供更舒適的環境。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    },
    {
      date: '2023.02.16',
      category: '案例研究 / 發布',
      title: 'TradFit 被認證為「J-Startup NIIGATA」，作為新潟縣的創新新創企業',
      content: `<p>TradFit 株式會社已被認證為「J-Startup NIIGATA」，作為新潟縣的創新新創企業。</p>
  <p>我們被評價為貢獻於區域經濟發展的企業。</p>
  <p><strong>■ 本案相關諮詢</strong><br>TradFit 株式會社<br>E-mail:info@tradift.com</p>`
    }
  ]

};

export default zhTW;
